export default __webpack_public_path__ + "static/media/studentempty@2x.35e56c9c.png";